import { generateId } from "@msuite/utils/strings";
import { createContext, type PropsWithChildren, useContext } from "react";

/** Interface */
interface ILightboxContext {
	itemHeight: string;
}

interface ILightboxContainerContext {
	containerId: string;
}

/** Context */
const LightboxContext = createContext<ILightboxContext>({} as ILightboxContext);
const LightboxContainerContext = createContext<ILightboxContainerContext>({
	containerId: generateId(),
} as ILightboxContainerContext);

/** Interface Provider Props */
interface ProviderProps extends PropsWithChildren, ILightboxContext {
	children: React.ReactNode;
}

/** Provider */
function Provider({ children, itemHeight }: ProviderProps) {
	return <LightboxContext.Provider value={{ itemHeight }}>{children}</LightboxContext.Provider>;
}

/** Container Provider */
function ContainerProvider({
	children,
	containerId,
}: PropsWithChildren & ILightboxContainerContext) {
	return (
		<LightboxContainerContext.Provider value={{ containerId }}>
			{children}
		</LightboxContainerContext.Provider>
	);
}

/** Hooks */
function useLightbox() {
	return useContext(LightboxContext);
}

function useLightboxContainer() {
	return useContext(LightboxContainerContext);
}

export { ContainerProvider, Provider, useLightbox, useLightboxContainer };
